const MONTHS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];

// « 2026-09-29 » → « 29 septembre 2026 », sans dépendre de l'ICU du navigateur
// (même rendu au pré-rendu et à l'hydratation).
export const formatDateFr = (iso) => {
  const [y, m, d] = iso.split("-").map(Number);
  return `${d === 1 ? "1er" : d} ${MONTHS[m - 1]} ${y}`;
};
